module.exports = __webpack_public_path__ + "static/media/notificationUser.4355078f.mp3";